import type { Urgency } from './due';

/**
 * One rule for every date: waiting before it can start, overdue once past, soon inside the reminder
 * window (`remindDays` 0: only on the day), otherwise just scheduled (docs/decisions/0012).
 */
export function dueState(days: number, remindDays: number, startsInDays?: number | null): Urgency {
  if (startsInDays != null && startsInDays > 0) return 'waiting';
  if (days < 0) return 'overdue';
  if (days <= remindDays) return 'soon';
  return 'scheduled';
}
